// extracted by mini-css-extract-plugin
module.exports = {"device_emulator_wrapper":"styles_device_emulator_wrapper__166dd","fullscreen":"styles_fullscreen__1lYCc","device_emulator":"styles_device_emulator__3WKw0"};